
































































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, reactive, ref } from '@vue/composition-api';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartStandardScoring',
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object
    },
    interpretations: {
      type: String
    },
    small: {
      type: Boolean
    }
  },
  setup(properties) {
    const value = Math.round(properties.aggregates.avg) || 0;
    const status: any = properties.aggregates.indicator;

    const missingNorms = computed(() => !properties.norms);

    const colors = reactive({
      neutralValue: '#B3BBCE',
      neutral: '#F2F2F2',
      goodRange: '#33CC30',
      warningRange: '#FFAA02',
      badRange: '#ED361E',
      noRange: '#003DD1'
    });

    // SYMMETRY CHART
    const radius = ref(125);
    const strokeWidth = computed(() => {
      return radius.value * 0.07;
    });
    const innerRadius = computed(() => {
      return radius.value - strokeWidth.value;
    });
    const circumference = computed(() => {
      return innerRadius.value * 2 * Math.PI;
    });
    const arc = computed(() => {
      return circumference.value * (180 / 360);
    });
    const dashArray = computed(() => {
      return `${arc.value} ${circumference.value}`;
    });
    const offset = computed(() => {
      return arc.value - (value / 100) * arc.value;
    });
    const transform = computed(() => {
      return `rotate(180, ${radius.value}, ${radius.value})`;
    });
    const valueColor = computed(() => {
      switch (status) {
        case 'warning':
          return colors.warningRange;
        case 'bad':
          return colors.badRange;
        case 'good':
          return colors.goodRange;
        default:
          return colors.neutral;
      }
    });

    return {
      // Values
      value,
      missingNorms,
      radius,
      strokeWidth,
      innerRadius,
      colors,
      dashArray,
      offset,
      transform,
      valueColor
    };
  }
});
